import React, { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
const OrderOperatorsDashboard = lazy(() => import('../containers/OrderOperators/OrderOperatorsDashboard'));
function OrderOperatorsRouts({ url }) {
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: url },
            React.createElement(OrderOperatorsDashboard, { url: url }))));
}
export default OrderOperatorsRouts;
